import { unref as _unref, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "menu-line" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "menu-line" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "menu-line" }, null, -1)
const _hoisted_4 = [
  _hoisted_1,
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "right-wrap" }
const _hoisted_6 = {
  key: 2,
  class: "header-text"
}
const _hoisted_7 = { class: "balance-wrap" }
const _hoisted_8 = { class: "balance-value" }
const _hoisted_9 = { class: "balance-wrap pointer" }
const _hoisted_10 = { class: "balance-value" }
const _hoisted_11 = {
  key: 0,
  class: "action-bar"
}
const _hoisted_12 = { class: "user-id" }

import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore, useAccountStore, useReddotStore } from "@/store";
import { useHelpTool } from '@/hooks';
import MenuPanel from '@/components/MenuPanel.vue';


export default {
  __name: 'HeaderBar',
  props: ['showDe'],
  setup(__props) {



const { backgroundByTheme, imageByTheme } = useHelpTool()

const userStore = useUserStore();
const { uid, avatar, vip, invitationCode } = storeToRefs(userStore);
const accountStore = useAccountStore();
const { balance, point } = storeToRefs(accountStore);
const redDotStore = useReddotStore();
const { loginBonusRewardNum, inboxUnread, taskRewardNum } = storeToRefs(redDotStore);

const showMenuPanel = ref(false);


return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _component_van_button = _resolveComponent("van-button")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "header-bar flex",
      style: _normalizeStyle(_unref(backgroundByTheme)('header-bg.png'))
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "menu-icon",
        onClick: _cache[0] || (_cache[0] = $event => (showMenuPanel.value = true))
      }, _hoisted_4)), [
        [_directive_audio]
      ]),
      _withDirectives(_createVNode(_component_van_image, {
        class: "header-logo",
        src: _unref(imageByTheme)('logo.png'),
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$router.push({ name: 'game' })))
      }, null, 8, ["src"]), [
        [_directive_audio]
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.$router.currentRoute.value.name === 'login' || _ctx.$router.currentRoute.value.name === 'register' || _ctx.$router.currentRoute.value.name === 'forgetPassword')
          ? _withDirectives((_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "service-btn flex justify-center",
              onClick: _cache[2] || (_cache[2] = $event => (_ctx.$router.push({ name: 'livechat' })))
            }, [
              _createVNode(_component_van_image, {
                class: "service-icon",
                src: require('@/assets/img/common/service-icon.png')
              }, null, 8, ["src"])
            ])), [
              [_directive_audio]
            ])
          : (!_unref(uid))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                  class: "header-btn",
                  onClick: _cache[3] || (_cache[3] = $event => (_ctx.$router.push({ name: 'login' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.login')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_audio]
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_van_button, {
                  class: "header-btn ghost",
                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.$router.push({ name: 'register' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.register')), 1)
                  ]),
                  _: 1
                })), [
                  [_directive_audio]
                ])
              ], 64))
            : (_ctx.$router.currentRoute.value.name === 'profile')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('user.profile').toUpperCase()), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_van_image, {
                      class: "coin-icon",
                      src: require('@/assets/img/common/coin.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_8, "P" + _toDisplayString(_ctx.$filter.outputAmount(_unref(balance))), 1),
                    _withDirectives(_createVNode(_component_van_image, {
                      class: "action-icon",
                      src: require('@/assets/img/common/refresh.png'),
                      onClick: _cache[5] || (_cache[5] = $event => (_unref(accountStore).fetchBalance()))
                    }, null, 8, ["src"]), [
                      [_directive_audio]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_van_image, {
                      class: "pointer-icon",
                      src: require('@/assets/img/common/pointer.png')
                    }, null, 8, ["src"]),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$filter.outputAmount(_unref(point))), 1),
                    _withDirectives(_createVNode(_component_van_image, {
                      class: "action-icon",
                      src: require('@/assets/img/common/exchange.png'),
                      onClick: _cache[6] || (_cache[6] = $event => (_ctx.$router.push({ name: 'exchange' })))
                    }, null, 8, ["src"]), [
                      [_directive_audio]
                    ])
                  ])
                ], 64))
      ])
    ], 4),
    (_ctx.$router.currentRoute.value.name === 'game' && _unref(uid))
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "action-btn",
            style: _normalizeStyle(_unref(backgroundByTheme)('withdraw-bg.png')),
            onClick: _cache[7] || (_cache[7] = $event => (_ctx.$router.push({ name: 'withdraw' })))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('common.withdraw')), 1)
          ], 4)), [
            [_directive_audio]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "user-vip",
            onClick: _cache[8] || (_cache[8] = $event => (_ctx.$router.push({ name: 'profile' })))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('vip.vip').toUpperCase()) + " " + _toDisplayString(_unref(vip)), 1)
          ])), [
            [_directive_audio]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "action-btn",
            style: _normalizeStyle(_unref(backgroundByTheme)('deposit-bg.png')),
            onClick: _cache[9] || (_cache[9] = $event => (_ctx.$router.push({ name: 'recharge' })))
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('common.deposit')), 1)
          ], 4)), [
            [_directive_audio]
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('label.userId')) + ": " + _toDisplayString(_unref(invitationCode)), 1)
        ]))
      : _createCommentVNode("", true),
    _createVNode(MenuPanel, {
      show: showMenuPanel.value,
      onOnClose: _cache[10] || (_cache[10] = $event => (showMenuPanel.value = false))
    }, null, 8, ["show"])
  ], 64))
}
}

}